import styled from 'styled-components'
import { Image, Container, Segment, Card } from 'semantic-ui-react'
import { BasedBodyContainer, BasedFullWidthBackgroundContainer } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)`
    & .list.bulleted>.item:before {
        color: #049842;
    }
`

export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #def4e7;
`

export const ThemedText = styled.span`
    color: #049842;
`

export const BodySegment = styled(Segment)`
    && {
        font-size: 1em;
        /* margin: -1em; */
    }
`

export const IconsWrapper = styled.div`
    @media (min-width: 992px) {
        padding: 1em;
    }
`

export const CenterText = styled.div`
    text-align: center;
`

export const PopupSegment = styled(Segment)`
    &:before {
        position: absolute;
        content: '';
        width: 0.71428571em;
        height: 0.71428571em;
        background: #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        z-index: 2;
        box-shadow: -1px -1px 0 0 rgba(34,36,38,.1);
        top: -0.35em;
        left: ${({ $position }) => $position == 1 ? '15%' : $position == 2 ? '48%' : '82%'};
        right: auto;
        bottom: auto;
        margin-left: 0;
    }
`
export const FirstSegment = styled(PopupSegment)`
    &:before {
        left: 150px;
    }
`
export const LeftBorderedSegment = styled.div`
    border-left: 3px solid #049842;
    padding-left: .3em;
    height: 100%;
`

export const ThemedCard = styled(Card)`
    &&&& {
        box-shadow: 0 1px 3px 0 #049842, 0 0 0 1px #049842;

        @media (min-width: 768px) {
            width: calc(33.33333333333333% - 1em);
            margin-left: .5em;
            margin-right: .5em;
        }

        &>.content {
            padding: .5em;
        }
    }
`

